import {
    selectDoc,
    event,
    toggleClass,
    hasClass,
    isVisible,
    ajax,
    selectArr,
    removeClass,
    addClass
} from "../utils/utils";

import {addCartItemData, removeCartItem} from "../helpers/service.cart";

import {notify} from "../helpers/service.notification";

import {TAH} from "./component.tah";

import {hideNavComponents, toggleCheckOutSide} from "./component.nav";

const props = {
    body: selectDoc('body'),
    pageContainer: selectDoc('#PageContainer'),
    navCta: selectDoc('#cta-cart'),
    navIcon: selectDoc('#cta-cart .cart'),
    wsMinicart: selectDoc('#ws-minicart'),
    minicartContentNoTah: selectDoc('#ws-minicart #cart-items'),
    minicartContentTah: selectDoc('#ws-minicart #tah-kit .tah-items'),

    emptyContent: selectDoc('#ws-minicart .content.content-empty'),
    minicartContent: selectDoc('#ws-minicart .content.content-items'),
    emptyFooter: selectDoc('#ws-minicart .footer .summary.empty'),
    itemsFooter: selectDoc('#ws-minicart .footer .summary.items'),

    minicartCounter: selectArr(('.minicart-counter')),
    closeMain: selectDoc('#ws-minicart #close-minicart'),
    mainCounter: selectDoc('.items-count .main-count'),
    cartSubtotal: selectDoc('#cart-subtotal'),
    closeMini: selectDoc('#close-mini'),
    tahRemovesItem: selectArr(('.remove-tah-item')),
    tahItems: selectArr(('.tah-item')),
    tahRemoveKit: selectArr(('.remove-tah-kit')),
    tahKit: selectDoc('#tah-kit'),
    tahKitCart: selectDoc('#tah-kit-cart'),
    tahIcons: selectArr('#tah-icons .box-icon'),
    overlay: selectDoc('#ws-minicart #overlay'),
    addingWarranty: false
};

const redirectMiniCart = () => {
    let url = window.location.href;
    if (url.indexOf('?') > -1) {
        url += '&minicart=open'
    } else {
        url += '?minicart=open'
    }
    window.location.href = url;
}

const toggleOverlay = () => {
    if (props.overlay && props.wsMinicart) {
        toggleClass(props.overlay, 'show')
        toggleClass(props.wsMinicart, 'disabled')
    }
}

export const toggleMiniCart = (closeMenus = true) => {
    toggleClass(props.wsMinicart, 'show');
    toggleClass(props.navIcon, 'active');

    if (hasClass(props.wsMinicart, 'show')) {
        //Hide other components
        hideNavComponents(true,false);

        //Show
        toggleCheckOutSide();
        toggleCheckOutSide(props.wsMinicart, props.navIcon);
        addClass(document.body, 'child-open');
        addClass(document.body, 'no-scroll');
        props.wsMinicart.style.height = window.innerHeight + 'px';
    } else {
        //Hide
        toggleCheckOutSide();
        closeMenus ? removeClass(document.body, 'child-open') : '';
        removeClass(document.body, 'no-scroll');
    }
}

const recursionDelete = (removeFun, index, items) => {
    if (index < items.length) {
        removeFun.apply(this, [(items[index].getAttribute('data-line') - index)]).then(function () {
            recursionDelete(removeFun, index += 1, items)
        })
    } else {
        if (props.minicartContentTah) {
            props.minicartContentTah.parentNode.style.display = 'none';
            MiniCart.redirect()
        }
    }
}

/** ---------------------------- **/

const initNav = () => {
    event(props.navCta, 'click', toggleMiniCart)

    if (props.closeMini) {
        event(props.closeMini, 'click', function () {
            toggleMiniCart();
        })
    }
}

const initActions = () => {
    /**
     * @param line
     * @param qty
     * @param gtm
     */
    const updateCart = (line, qty) => {
        //GTM
        if(typeof dataLayer != 'undefined') {
            dataLayer.push({
                'event': 'update-cart-item',
                'category': 'click',
                'line': line,
                'qty': qty
            });
        }
        ajax('POST', "/cart/change.js", JSON.stringify({
            quantity: qty,
            line: line
        })).then(function (response) {
            redirectMiniCart()
        });
    }

    selectArr(('.update-minicart-item')).map(action => {
        event(action, 'click', function () {
            toggleOverlay();

            let qty = parseInt(action.getAttribute('data-qty')),
                line = parseInt(action.getAttribute('data-line'));

            action.disabled = true;

            // Warranty validation
            // If parent product has warranty, then remove warranty.
            let warranty = selectDoc(`div#warranty-${line}.warranty-added`);
            if (warranty && qty === 0) {
                if (line > 1) {
                    line -= 1;
                }
                removeCartItem(warranty.getAttribute('data-line'))
                    .then(function () {
                        updateCart(line, qty, action)
                    })
            } else {
                // Warranty validation
                //Stop process if qty of warranties on cart will be greater than the qty of parent products.
                let counter = selectDoc(`.cart-warranty-item span.item-count-${line}`)
                if (counter) {
                    let limit = parseInt(counter.getAttribute('data-limit'));
                    if (qty > limit) {
                        toggleOverlay();
                        return false;
                    }
                }

                updateCart(line, qty, action)
            }
        })
    })

    selectArr(('.atc-warranty')).map(warranty => {
        event(warranty, 'click', function () {
            if (!props.addingWarranty) {
                props.addingWarranty = true;
                let id = selectDoc('.disclaimer strong', warranty.parentNode),
                    qty = selectDoc(`.${warranty.id}`),
                    price = '';

                if (id && qty) {
                    price = id.innerText;
                    id = id.getAttribute('data-war');
                    let parentId = warranty.id;
                    addCartItemData(JSON.stringify({
                        items: [
                            {
                                quantity: parseInt(qty.innerText),
                                id: id,
                                properties: {
                                    'warranty_parent_product': parentId.replace('parent-warranty-', '')
                                }
                            }
                        ]
                    }), {
                        'name': 'Warranty',
                        'id': id,
                        'price': price,
                        'quantity': parseInt(qty.innerText)
                    }).then(function (response) {
                        redirectMiniCart()
                    });
                }
            }
        })
    })

    selectArr(('.warranty-count button')).map(counter => {
        event(counter, 'click', function () {
            let qty = parseInt(counter.getAttribute('data-qty'))
            if (qty > 0) {
                let number = selectDoc('.item-count', counter.parentNode);
                if (number) {
                    if (qty <= parseInt(number.getAttribute('data-limit'))) {
                        number.innerText = qty;

                        if (hasClass(counter, 'less-icon')) {
                            let opposite = selectDoc('.plus-icon', counter.parentNode)
                            counter.setAttribute('data-qty', (qty - 1))
                            opposite.setAttribute('data-qty', (qty + 2 - 1));
                        } else {
                            let opposite = selectDoc('.less-icon', counter.parentNode)
                            counter.setAttribute('data-qty', (qty + 1))
                            opposite.setAttribute('data-qty', (qty - 2 + 1));
                        }
                    }
                }
            }
        })
    })
}

const checkUrl = () => {
    let params = new URL(document.URL).searchParams;

    if (params.get('minicart')) {
        let currentUrl = new URL(document.URL);
        if (currentUrl.pathname !== '/cart') {
            toggleMiniCart();
        }

        let baseUrl = window.location.href.split("?")[0];
        window.history.pushState('name', document.title, baseUrl);
    }

    if (params.has('customer_posted') || params.has('contact[tags]')) {
        window.addEventListener('load', function () {
            setTimeout(function () {
                window.scrollTo({
                    top: document.body.scrollHeight,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 700)
        });
    }
}

const initTryAtHomeKit = () => {
    const updateMiniCart = () => {
        new Promise(resolve => {
            ajax('GET', "/cart.js")
                .then(function (response) {
                    resolve(response);
                });
        }).then(
            function (response) {
                response = JSON.parse(response);
                if (response.status === 200) {
                    const cartData = JSON.parse(response.response);
                    if (cartData.items.length > 0) {
                        let tahCount = 0,
                            line = 1,
                            tahHandles = [];
                        cartData.items.map(item => {
                            if (item.properties) {
                                if (item.properties.isTah) {
                                    tahCount++
                                    tahHandles.push({
                                        properties: item.properties,
                                        id: item.id,
                                        line: line
                                    })
                                }
                            }
                            line++;
                        })

                        switch (tahCount) {
                            case 1:
                                tahHandles[0].bundle = 'Bundle3';
                                break;
                            case 2:
                                tahHandles[0].bundle = 'Bundle2';
                                tahHandles[1].bundle = 'Bundle1';
                                break;
                            default:
                                break
                        }

                        TAH.processBundles(tahCount, null, null, tahHandles, null);
                    } else {
                        MiniCart.redirect()
                    }
                } else {
                    console.log('Error fetching cart products data.');
                }
            })
    }

    if (props.tahKit) {
        if (props.tahItems.length < 1) {
            props.tahKit.style.display = 'none'
        } else {
            props.tahKit.style.display = 'block'
            if (props.tahKitCart) {
                props.tahKitCart.style.display = 'block'
            }

            if (props.tahIcons) {
                props.tahIcons.map((icon, index) => {
                    icon.classList.remove('selected')
                    if (index < props.tahItems.length) {
                        icon.classList.add('selected')
                    }
                })
            }
        }
    }

    if (props.tahRemoveKit) {
        props.tahRemoveKit.map(removeKit => {
            event(removeKit, 'click', function () {
                notify('Confirm Removal',
                    `Are you sure you don't want this kit anymore?`,
                    'Yes, Remove', '/', true).then(function (response) {
                    if (response) {
                        toggleOverlay()
                        recursionDelete(removeCartItem, 0, props.tahItems)
                    }
                })
            })
        })
    }

    if (props.tahRemovesItem) {

        let currentUrl = new URL(document.URL),
            countLess = 1;
        if (currentUrl.pathname === '/cart') {
            countLess = 2;
        }

        props.tahRemovesItem.map(removeKitItem => {
            event(removeKitItem, 'click', function () {
                if ((props.tahRemovesItem.length - countLess) === 0) {
                    notify('Confirm Removal',
                        `Are you sure you don't want this kit anymore?`,
                        'Yes, Remove', '/', true).then(function (response) {
                        if (response) {
                            toggleOverlay()
                            removeCartItem(removeKitItem.getAttribute('data-line')).then(updateMiniCart)
                        }
                    })
                } else {
                    toggleOverlay()
                    removeCartItem(removeKitItem.getAttribute('data-line')).then(updateMiniCart)
                }
            })
        })
    }
}

const redirectEmptySpots = () => {
    selectArr('.empty-spot').map(empty => {
        event(empty, 'click', function () {
            location.href = '/collections/try-at-home'
        })
    })
}

const initializer = () => {
    initNav()
    initActions()
    checkUrl()
    initTryAtHomeKit()
    redirectEmptySpots()
}

export const MiniCart = {
    init: () => initializer(),
    redirect: () => redirectMiniCart(),
    toggleOverlay: () => toggleOverlay()
}
